import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from '../login/login.component';
import { HomeComponent } from '../home/home.component';
import { BasicDataComponent } from '../forms/basic-data/basic-data.component';
import { ApplicationFormComponent } from '../forms/application-form/application-form.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { DataService } from '../../core/services/data.service';
import { LoadingService } from '../../core/services/loading.service';
import { Subject, takeUntil } from 'rxjs';
import { AppState } from '../../core/models/AppState';
import { ChargingComponent } from '../../shared/components/charging/charging.component';

@Component({
  selector: 'app-master',
  standalone: true,
  imports: [
    CommonModule,
    LoginComponent,
    HomeComponent,
    BasicDataComponent,
    ApplicationFormComponent,
    HeaderComponent,
    FooterComponent,
    ChargingComponent
  ],
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss']
})
export class MasterComponent implements OnInit, OnDestroy {
  currentView: AppState['currentView'] | null = null;
  isLoading = true;
  private destroy$ = new Subject<void>();

  constructor(
    private dataService: DataService,
    private loadingService: LoadingService
  ) {
    this.loadingService.isLoading$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(loading => {
      this.isLoading = loading;
    });
  }

  ngOnInit() {
    this.loadingService.show();
    
    this.dataService.currentView$
      .pipe(takeUntil(this.destroy$))
      .subscribe(view => {
        this.currentView = view;
        this.loadingService.hide();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}